// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

export default styled(Drawer)(({ theme, ownerState }) => {
  const { palette, boxShadows, transitions, breakpoints, functions } = theme;
  const { transparentSidenav, miniSidenav } = ownerState;

  const sidebarWidth = 250;
  const { white, transparent } = palette;
  const { xxl } = boxShadows;
  const { pxToRem } = functions;

  const drawerOpenStyles = () => ({
    width: sidebarWidth,
    left: 0,
    transform: "translateX(0)",
    transition: transitions.create(["width", "transform", "background-color"], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),
    backgroundColor: transparentSidenav ? transparent.main : white.main,
    boxShadow: transparentSidenav ? "none" : xxl,
    position: "fixed"
  });

  const drawerCloseStyles = () => ({
    width: pxToRem(96),
    left: 0,
    transform: "translateX(0)",
    transition: transitions.create(["width", "transform", "background-color"], {
      easing: transitions.easing.easeIn,
      duration: transitions.duration.shorter,
    }),
    backgroundColor: transparentSidenav ? transparent.main : white.main,
    boxShadow: transparentSidenav ? "none" : xxl,
    position: "fixed",
    overflowX: "hidden"
  });

  const drawerMobileStyles = () => ({
    width: pxToRem(sidebarWidth),
    maxWidth: "85vw",
    left: 0,
    transform: miniSidenav ? "translateX(-110%)" : "translateX(0)",
    transition: transitions.create("transform", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),
    backgroundColor: transparentSidenav ? transparent.main : white.main,
    boxShadow: transparentSidenav ? "none" : xxl,
    position: "fixed",
    overflowX: "hidden",
  });

  return {
    "& .MuiDrawer-paper": {
      border: "none",
      ...drawerMobileStyles(),
      [breakpoints.up("xl")]: miniSidenav ? drawerCloseStyles() : drawerOpenStyles(),
      transition: transitions.create(["width", "transform", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
    },
  };
});
